import { createFileRoute } from "@tanstack/react-router";
import { PrintServicePage } from "./services_.print";

export const Route = createFileRoute("/dev_/service_/print-advertisements-services")({
  head: () => ({
    meta: [
      {
        title: "Print Advertisements Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "High-Impact Print Advertising & Newspaper Campaign Planning.",
      },
    ],
  }),
  component: PrintServicePage,
});
